import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Footer() {
  return (
    <footer className="bg-background-950 border-t border-background-800/40">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <i className="ri-movie-2-line text-primary-400 text-2xl"></i>
              <span className="text-lg font-bold text-white font-heading">夜猫电影院</span>
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed">
              高清电影免费在线观看，免费电视剧大全不缓冲，高清影视熬夜追剧，尽享高清影视。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">快速导航</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">首页</Link></li>
              <li><Link to="/category/hot" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">热门推荐</Link></li>
              <li><Link to="/category/tv" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">电视剧</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">影视分类</h4>
            <ul className="space-y-2">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.id}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">{cat.name}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">联系我们</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-sm text-foreground-400">
                <i className="ri-mail-line text-primary-400 mt-0.5"></i>
                <span>contact@nightowlcinema.com</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-foreground-400">
                <i className="ri-customer-service-line text-primary-400 mt-0.5"></i>
                <span>在线客服：7×24小时</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-foreground-400">
                <i className="ri-map-pin-line text-primary-400 mt-0.5"></i>
                <span>中国 · 北京</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-800/40 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2024 夜猫电影院. 本站所有内容均来自互联网，仅供学习交流使用。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors" rel="nofollow">服务条款</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors" rel="nofollow">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}